module.exports = __webpack_public_path__ + "static/img/品牌魅力.ae25cc28.png";